import { render, staticRenderFns } from "./BusinessPayrollForms.vue?vue&type=template&id=a226ac22&scoped=true&"
import script from "./BusinessPayrollForms.vue?vue&type=script&lang=ts&"
export * from "./BusinessPayrollForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226ac22",
  null
  
)

export default component.exports